import { HiOutlineChevronLeft, HiOutlineDesktopComputer } from 'react-icons/hi';

export const TopBar = ({ bookTitle, chapterTitle, onHome, onFullscreen }) => {
  return (
    <div
      className="w-full h-16 shrink-0 border-b z-50 flex items-center px-4 justify-between"
      style={{ background: 'var(--card)', borderColor: 'var(--card-border)', boxShadow: 'var(--shadow-1)' }}
    >
      <div className="flex items-center gap-4 min-w-0">
        <button
          onClick={onHome}
          className="button-ghost p-2 rounded-full transition-colors shrink-0"
          title="Back to Home"
        >
          <HiOutlineChevronLeft className="w-6 h-6" />
        </button>
        <div className="flex flex-col max-w-md min-w-0">
          <span className="text-xs font-medium truncate" style={{ color: 'var(--foreground-muted)' }}>{bookTitle || 'Loading...'}</span>
          <span className="text-sm font-bold truncate" style={{ color: 'var(--foreground)' }}>{chapterTitle || 'Loading...'}</span>
        </div>
      </div>
      <button
        onClick={onFullscreen}
        className="button-ghost p-2 rounded-full transition-colors"
        title="Toggle Fullscreen"
      >
        <HiOutlineDesktopComputer className="w-6 h-6" />
      </button>
    </div>
  );
};
